






















import { defineComponent, PropType } from '@nuxtjs/composition-api';

type Brand = {
  id: number;
  title: string;
  url: string;
  media_path: string;
  media_file_name: string;
  overlay_text?: string;
};

export default defineComponent({
  name: 'LogosOnly',
  props: {
    data: {
      type: Object as PropType<{
        urls?: Brand[];
        custom_fields: Record<string, any>;
      }>,
      required: true,
      default: () => ({ media: [] })
    }
  }
});
